var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3586.85 3581.98",
    style: {
      enableBackground: "new 0 0 3586.85 3581.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#10B5F4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2098.77,93.53l11.66-64.47l9.85,1.78l-11.66,64.48L2098.77,93.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2194.33,113.33l15.31-63.71l9.73,2.34l-15.31,63.71L2194.33,113.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2288.59,138.55l18.92-62.73l9.58,2.89l-18.92,62.73L2288.59,138.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2381.28,169.11l22.46-61.55l9.4,3.43l-22.46,61.55L2381.28,169.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2472.05,204.9l25.93-60.17l9.19,3.96l-25.93,60.17L2472.05,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2560.66,245.81l29.31-58.6l8.95,4.48l-29.32,58.6L2560.66,245.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2646.79,291.68l32.59-56.84l8.68,4.98l-32.59,56.84L2646.79,291.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2730.19,342.36l35.76-54.9l8.39,5.46l-35.76,54.9L2730.19,342.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2810.58,397.67l38.8-52.8l8.07,5.93l-38.8,52.8L2810.58,397.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2887.74,457.43l41.71-50.53l7.72,6.37l-41.71,50.53L2887.74,457.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2961.39,521.44l44.49-48.1l7.35,6.8l-44.49,48.1L2961.39,521.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3031.35,589.51l47.13-45.52l6.95,7.2l-47.12,45.52L3031.35,589.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3097.36,661.39l49.61-42.8l6.54,7.58l-49.61,42.8L3097.36,661.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3159.22,736.88l51.94-39.93l6.1,7.94l-51.94,39.93L3159.22,736.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3216.72,815.73l54.11-36.94l5.64,8.27l-54.11,36.94L3216.72,815.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3269.68,897.69l56.12-33.82l5.17,8.57l-56.12,33.82L3269.68,897.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3317.91,982.52l57.94-30.59l4.67,8.85l-57.94,30.59L3317.91,982.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3361.26,1069.97l59.59-27.24l4.16,9.1l-59.59,27.24L3361.26,1069.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3399.55,1159.72l61.04-23.81l3.64,9.33l-61.04,23.81L3399.55,1159.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3432.67,1251.52l62.3-20.29l3.1,9.52l-62.3,20.29L3432.67,1251.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3460.5,1345.03l63.36-16.7l2.55,9.68l-63.36,16.7L3460.5,1345.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3482.95,1439.99l64.21-13.06l2,9.81l-64.21,13.06L3482.95,1439.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3499.96,1536.1l64.84-9.4l1.44,9.91l-64.84,9.4L3499.96,1536.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3511.5,1633l65.27-5.72l0.87,9.97l-65.27,5.72L3511.5,1633z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3517.57,1730.43l65.49-2.05l0.31,10.01l-65.49,2.05L3517.57,1730.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3518.19,1828.04l65.5,1.59l-0.24,10.01l-65.5-1.59L3518.19,1828.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3513.37,1925.55l65.31,5.25l-0.8,9.98l-65.31-5.25L3513.37,1925.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3503.09,2022.62l64.91,8.93l-1.36,9.92l-64.91-8.93L3503.09,2022.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3487.32,2118.93l64.3,12.6l-1.93,9.82l-64.3-12.6L3487.32,2118.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3466.11,2214.19l63.47,16.24l-2.48,9.7l-63.47-16.24L3466.11,2214.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3439.51,2308.06l62.44,19.84l-3.03,9.54l-62.44-19.84L3439.51,2308.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3407.59,2400.27l61.21,23.37l-3.57,9.35l-61.21-23.37L3407.59,2400.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3370.47,2490.53l59.78,26.82l-4.1,9.13l-59.78-26.82L3370.47,2490.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3328.27,2578.52l58.16,30.17l-4.61,8.89l-58.16-30.17L3328.27,2578.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3281.13,2663.99l56.36,33.42l-5.11,8.61l-56.36-33.42L3281.13,2663.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3229.24,2746.64l54.38,36.55l-5.58,8.31l-54.38-36.55L3229.24,2746.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3172.74,2826.24l52.23,39.56l-6.04,7.98l-52.23-39.57L3172.74,2826.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3111.85,2902.53l49.91,42.44l-6.48,7.63l-49.91-42.44L3111.85,2902.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3046.76,2975.26l47.45,45.19l-6.9,7.25l-47.45-45.19L3046.76,2975.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2977.67,3044.23l44.83,47.78l-7.3,6.85l-44.83-47.78L2977.67,3044.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2904.83,3109.18l42.07,50.23l-7.67,6.43l-42.07-50.23L2904.83,3109.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2828.45,3169.94l39.17,52.52l-8.02,5.98l-39.17-52.52L2828.45,3169.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2748.74,3226.3l36.14,54.65l-8.35,5.52l-36.14-54.65L2748.74,3226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2665.99,3278.06l32.99,56.61l-8.65,5.04l-32.99-56.61L2665.99,3278.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2580.46,3325.03l29.73,58.39l-8.92,4.54l-29.73-58.39L2580.46,3325.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2492.38,3367.08l26.36,59.98l-9.16,4.03l-26.36-59.98L2492.38,3367.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2402.08,3404.05l22.9,61.39l-9.38,3.5l-22.9-61.39L2402.08,3404.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2309.81,3435.8l19.36,62.59l-9.56,2.96l-19.36-62.59L2309.81,3435.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2215.89,3462.24l15.76,63.6l-9.72,2.41l-15.76-63.6L2215.89,3462.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2120.57,3483.29l12.11,64.39l-9.84,1.85l-12.11-64.39L2120.57,3483.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2024.24,3498.88l8.44,64.97l-9.93,1.29l-8.44-64.97L2024.24,3498.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1927.17,3509l4.76,65.35l-9.98,0.73l-4.76-65.35L1927.17,3509z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1829.65,3513.65l1.1,65.51l-10.01,0.17l-1.1-65.51L1829.65,3513.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1732.05,3512.86l-2.54,65.47l-10-0.39l2.54-65.47L1732.05,3512.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1634.64,3506.62l-6.21,65.23l-9.97-0.95l6.21-65.22L1634.64,3506.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1537.72,3494.91l-9.89,64.77l-9.9-1.51l9.89-64.77L1537.72,3494.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1441.67,3477.74l-13.55,64.1l-9.79-2.07l13.55-64.1L1441.67,3477.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1346.73,3455.12l-17.18,63.23l-9.66-2.62l17.18-63.23L1346.73,3455.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1253.25,3427.12l-20.76,62.14l-9.49-3.17l20.76-62.14L1253.25,3427.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1161.52,3393.84l-24.27,60.86l-9.3-3.71l24.27-60.86L1161.52,3393.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1071.82,3355.38l-27.7,59.38l-9.07-4.23l27.7-59.38L1071.82,3355.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M984.48,3311.9l-31.02,57.71l-8.82-4.74l31.02-57.71L984.48,3311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M899.71,3263.5l-34.25,55.86l-8.53-5.23l34.25-55.86L899.71,3263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M817.83,3210.4l-37.35,53.83l-8.22-5.71l37.35-53.83L817.83,3210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M739.07,3152.75l-40.33,51.64l-7.89-6.16l40.33-51.64L739.07,3152.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.67,3090.74l-43.17,49.29l-7.53-6.59l43.17-49.29L663.67,3090.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591.89,3024.59l-45.88,46.78l-7.15-7.01l45.88-46.78L591.89,3024.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.95,2954.51l-48.43,44.12l-6.74-7.4l48.43-44.12L523.95,2954.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.06,2880.71l-50.84,41.33l-6.31-7.77l50.84-41.33L460.06,2880.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.42,2803.43l-53.09,38.4l-5.87-8.11l53.09-38.4L400.42,2803.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.24,2722.92l-55.17,35.34l-5.4-8.43l55.17-35.34L345.24,2722.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.72,2639.43l-57.09,32.16l-4.91-8.72l57.09-32.16L294.72,2639.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.99,2553.19l-58.82,28.86l-4.41-8.99l58.82-28.86L248.99,2553.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.25,2464.52l-60.37,25.47l-3.89-9.22l60.37-25.47L208.25,2464.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.64,2373.69l-61.72,21.99l-3.36-9.43l61.72-21.99L172.64,2373.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.25,2280.95l-62.87,18.43l-2.82-9.61l62.87-18.43L142.25,2280.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.21,2186.63l-63.82,14.82l-2.26-9.75l63.82-14.82L117.21,2186.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.58,2091.05l-64.56,11.16l-1.71-9.86l64.56-11.16L97.58,2091.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,1994.48l-65.09,7.49l-1.14-9.94l65.09-7.49L83.4,1994.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.71,1897.25l-65.41,3.81l-0.58-9.99l65.41-3.81L74.71,1897.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.54,1799.44l-65.51,1.06l-0.16-10.01l65.51-1.06L71.54,1799.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.68,1702.06l-65.43-3.49l0.53-10l65.43,3.49L73.68,1702.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.33,1604.78l-65.13-7.16l1.09-9.95l65.13,7.16L81.33,1604.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.46,1508.07l-64.62-10.84l1.66-9.87l64.62,10.84L94.46,1508.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.06,1412.28l-63.9-14.5l2.22-9.76l63.9,14.5L113.06,1412.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.08,1317.71l-62.97-18.12l2.77-9.62l62.97,18.12L137.08,1317.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.46,1224.63l-61.83-21.68l3.31-9.45l61.83,21.68L166.46,1224.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.09,1133.42l-60.49-25.17l3.85-9.24l60.49,25.17L201.09,1133.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.87,1044.31l-58.96-28.57l4.36-9.01l58.96,28.57L240.87,1044.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.65,957.59l-57.25-31.87l4.87-8.75l57.25,31.87L285.65,957.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.27,873.57l-55.35-35.06l5.36-8.46l55.35,35.06L335.27,873.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.56,792.49l-53.28-38.13l5.83-8.14l53.28,38.13L389.56,792.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.36,714.58l-51.05-41.08l6.28-7.8l51.05,41.08L448.36,714.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.44,640.13l-48.65-43.88l6.7-7.43l48.65,43.88L511.44,640.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.62,569.33l-46.11-46.55l7.11-7.04l46.11,46.55L578.62,569.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.67,502.42l-43.42-49.07l7.5-6.63l43.42,49.07L649.67,502.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M724.37,439.62l-40.58-51.44l7.86-6.2l40.58,51.44L724.37,439.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802.5,381.13l-37.62-53.64l8.2-5.75l37.62,53.64L802.5,381.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M883.8,327.14l-34.53-55.69l8.51-5.27l34.53,55.69L883.8,327.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M968.01,277.85l-31.32-57.55l8.79-4.78l31.32,57.55L968.01,277.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1054.88,233.41l-28-59.24l9.05-4.28l28,59.24L1054.88,233.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1144.14,193.98l-24.58-60.73l9.28-3.76l24.58,60.73L1144.14,193.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1235.51,159.69l-21.08-62.04l9.48-3.22l21.08,62.04L1235.51,159.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1328.68,130.67l-17.5-63.14l9.65-2.67l17.5,63.14L1328.68,130.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1423.36,107.02l-13.88-64.03l9.78-2.12l13.88,64.03L1423.36,107.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1519.23,88.79l-10.21-64.72l9.89-1.56l10.21,64.72L1519.23,88.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1615.97,76.03l-6.54-65.19l9.96-1l6.54,65.19L1615.97,76.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1713.29,68.75l-2.87-65.46l10-0.44l2.87,65.46L1713.29,68.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1810.81,66.9l1.06-65.51l10.01,0.16l-1.06,65.51L1810.81,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1908.49,70.52l4.44-65.37l9.99,0.68l-4.44,65.37L1908.49,70.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2005.63,79.58l8.11-65.02l9.93,1.24l-8.11,65.02L2005.63,79.58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.39e9fdcc4d739ceb93b8e1d2330a0036.svg";
export { ForwardRef as ReactComponent };